<template>
    <div v-if="mixer">
        <Box  @close="cerrar(false)" :width="'800px'">
            <template #top>Ver Mixer</template>
            <template #center>
                <div class="nj-card">
                    <div class="nj-cols form c2">
                        <div>
                            <div class="nj-label">Nombre</div>
                            <input type="text" class="nj-text" v-model="mixer.mix_nombre" disabled>
                        </div>
                        <div>
                            <div class="nj-label">Placa</div>
                            <input type="text" class="nj-text" v-model="mixer.mix_placa" disabled>
                        </div>
                        <div>
                            <div class="nj-label">Capacidad</div>
                            <input type="text" class="nj-text" v-model="mixer.mix_capacidad" disabled>
                        </div>
                        <div>
                            <div class="nj-label">Estado</div>
                            <input type="text" class="nj-text" v-model="mixer.est_nombre" disabled>
                        </div>
                    </div>
                </div>
            </template>
        </Box>
    </div>
</template>
<script>
import Toast from "../../util/toast"
import { Box } from "../components"
import { MixerService, ResponseStatus } from "../../services"

export default {
    name: "VerMixer",
    components: {
        Box
    },
    props: {
        mix_id: {
            type: Number
        }
    },
    data() {
        return {
            mixer: null,
        }
    },
    methods: {
        cerrar(condition) {
            this.$emit("close", { componente: 'ver', abrir: false, buscar: condition })
        }
    },
    mounted() {
        MixerService.obtener({
            mixer: {
                mix_id: this.mix_id
            }
        }).then(
            response => {
                if (ResponseStatus.isSuccess(response)) {
                    this.mixer = response.data
                }
                else {
                    Toast.error(response.message)
                }
            },
            error => {
                Toast.error(error)
                console.error(`error: `, error)
            }
        )
    }
}
</script>

<style scoped></style>